import React, { useContext } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import {
  ANIMATION,
  ICON,
  ILLUSTRATION,
  LINE,
  PICTURE,
  QR_CODE,
  SHAPE,
  STICKER,
  STOCK,
  SVG,
  TEXT,
  TYPE_FORM,
  JOT_FORM,
  UPLOAD,
  VIDEO,
  COLLAGE,
  TEXT_FRAME,
  BRAND,
  UPLOAD_VIDEO,
  PRICING_TABLE,
  FRAME,
  TEXT_ART,
  TIMELINE,
  SCOPE_OF_WORK,
  ITINERARY,
  PORTFOLIO,
  CASESTUDY,
  COUNTDOWN,
} from "../../../constants/editor";
import { hexToRGB, RGBToHex } from "../../../_helpers/utils";
import { EditorPanelContext } from "../../../containers/editor/EditorPanel";
import FontFamily from "./FontFamily";

let style = Object.assign({}, global);

const CopyStyle = props => {
  let { metadata, widgets } = useContext(EditorContext);
  let { copyStyle, updateCopyStyle } = useContext(EditorPanelContext);

  let isGroupWidget = document.getElementById(metadata.activeWidgetId[0])?.closest(".dhp-page-group");
  let colorWidgetIncludedList = [TEXT, LINE, SHAPE, ICON, ILLUSTRATION, STICKER, UPLOAD, QR_CODE, TEXT_FRAME, TEXT_ART];
  let outlineWidgetIncludeList = [TEXT, TEXT_ART];

  const copyCurrentWidgetStyle = () => {
    let targetWidgetIndex = widgets.findIndex(widget => widget.id === metadata.activeWidgetId[0]);

    document.getElementById("canvas-panel-area").classList.add("cursor-copy-style");

    let currentElem = document.getElementById(metadata.activeWidgetId[0]);
    let flipableAvailable =
      metadata.activeWidgetType[0] === PICTURE ||
      metadata.activeWidgetType[0] === ANIMATION ||
      (metadata.activeWidgetType[0] === VIDEO && [STOCK, BRAND, UPLOAD_VIDEO].includes(currentElem.dataset.source)) ||
      (metadata.activeWidgetType[0] === UPLOAD && currentElem.dataset.fileType !== SVG);
    let currentWidgetStyle = flipableAvailable
      ? {
          filter: currentElem.querySelector(" .dhp-widget-inner").childNodes[0].style.filter,
          shadow: currentElem.querySelector(" .flippable").style.filter,
          borderStyle: currentElem.querySelector(" .flippable").style.borderStyle,
          borderWidth: currentElem.querySelector(" .flippable").style.borderWidth,
          borderRadius: currentElem.querySelector(" .flippable").style.borderRadius,
          borderColor: currentElem.querySelector(" .flippable").style.borderColor,
        }
      : [TYPE_FORM, JOT_FORM].includes(metadata.activeWidgetType[0])
      ? {
          shadow: currentElem.querySelector(" .dhp-widget-inner").style.filter,
          borderStyle: currentElem.querySelector(" .dhp-widget-inner").childNodes[0].style.borderStyle,
          borderWidth: currentElem.querySelector(" .dhp-widget-inner").childNodes[0].style.borderWidth,
          borderRadius: currentElem.querySelector(" .dhp-widget-inner").childNodes[0].style.borderRadius,
          borderColor: currentElem.querySelector(" .dhp-widget-inner").childNodes[0].style.borderColor,
        }
      : metadata.activeWidgetType[0] === SHAPE &&
        ["Circles", "Triangles", "Basic"].includes(currentElem.dataset.category) &&
        parseInt(currentElem.dataset.version) >= 3
      ? {
          shadow: currentElem.querySelector(" .dhp-widget-inner").style.filter,
          borderStyle: currentElem.dataset.borderStyle ? currentElem.dataset.borderStyle : "none",
          borderWidth: currentElem.dataset.borderWidth,
          borderRadius: 0,
          borderColor: currentElem.dataset.borderColor,
        }
      : metadata.activeWidgetType[0] === SHAPE &&
        ["Circles", "Triangles", "Basic", "Rectangles"].includes(currentElem.dataset.category) &&
        parseInt(currentElem.dataset.version) < 3
      ? {
          shadow: currentElem.querySelector(" .dhp-widget-inner").style.filter,
        }
      : metadata.activeWidgetType[0] === COLLAGE
      ? {
          filter: currentElem.querySelector(".collage")?.style.filter,
          shadow: currentElem.querySelector(".dhp-widget-inner").style.filter,
        }
      : [PRICING_TABLE, TIMELINE].includes(metadata.activeWidgetType[0])
      ? {
          shadow: currentElem.querySelector(".dhp-widget-inner").style.filter,
          fontFamily: currentElem.querySelector(".pricingTable_editor").style.fontFamily
            ? currentElem.querySelector(".pricingTable_editor")?.style?.fontFamily
            : "Open Sans",
        }
      : [ITINERARY].includes(metadata.activeWidgetType[0])
      ? {
          shadow: currentElem.querySelector(".dhp-widget-inner").style.filter,
          fontFamily: currentElem.querySelector(".pricingTable_editor").style.fontFamily
            ? currentElem.querySelector(".pricingTable_editor")?.style?.fontFamily
            : "Open Sans",
          sectionHeader: currentElem?.querySelector(".pricing-table-section .card-header").style.backgroundColor
            ? RGBToHex(currentElem?.querySelector(".pricing-table-section .card-header").style.backgroundColor)
            : "#4472c4",
          sectionSubheader: currentElem?.querySelector(".item-label").style.backgroundColor
            ? RGBToHex(currentElem?.querySelector(".item-label")?.style.backgroundColor)
            : "#dae3f3",
          sectionBody: currentElem?.querySelector(".item-details").style.backgroundColor
            ? RGBToHex(currentElem?.querySelector(".item-details").style.backgroundColor)
            : "#ffffff",
          sectionBorder: currentElem?.querySelector(".pricing-table-section .card-body .item-label").style.borderBottom
            ? RGBToHex(
                `rgb${
                  currentElem
                    ?.querySelector(".pricing-table-section .card-body .item-label")
                    .style.borderBottom.split("rgb")[1]
                }`
              )
            : "#4472c4",
        }
      : [SCOPE_OF_WORK].includes(metadata.activeWidgetType[0])
      ? {
          shadow: currentElem.querySelector(".dhp-widget-inner").style.filter,
          fontFamily: currentElem.querySelector(".pricingTable_editor").style.fontFamily
            ? currentElem.querySelector(".pricingTable_editor")?.style?.fontFamily
            : "Open Sans",
          sectionHeader: currentElem?.querySelector(".scope-of-work-section .card-header").style.backgroundColor
            ? RGBToHex(currentElem?.querySelector(".scope-of-work-section .card-header").style.backgroundColor)
            : "#4472c4",
          sectionSubheader: currentElem?.querySelector(".item-label").style.backgroundColor
            ? RGBToHex(currentElem?.querySelector(".item-label")?.style.backgroundColor)
            : "#dae3f3",
          sectionBody: currentElem?.querySelector(".item-details").style.backgroundColor
            ? RGBToHex(currentElem?.querySelector(".item-details").style.backgroundColor)
            : "#ffffff",
          sectionBorder: currentElem?.querySelector(".scope-of-work-section .card-body .item-label").style.borderBottom
            ? RGBToHex(
                `rgb${
                  currentElem
                    ?.querySelector(".scope-of-work-section .card-body .item-label")
                    .style.borderBottom.split("rgb")[1]
                }`
              )
            : "#4472c4",
        }
      : [PORTFOLIO, CASESTUDY].includes(metadata.activeWidgetType[0])
      ? {
          shadow: currentElem.querySelector(".dhp-widget-inner").style.filter,
          fontFamily: currentElem.querySelector(".portfolio_editor").style.fontFamily
            ? currentElem.querySelector(".portfolio_editor")?.style?.fontFamily
            : "Open Sans",
          tagColor: !currentElem?.querySelector(".portfolio_editor .tags li")
            ? ""
            : currentElem?.querySelector(".portfolio_editor .tags li")?.style.backgroundColor
            ? RGBToHex(currentElem?.querySelector(".portfolio_editor .tags li")?.style.backgroundColor)
            : "#F2F2F2",
          frameColor: currentElem?.querySelector(".portfolio_editor .card .left").style.backgroundColor
            ? RGBToHex(currentElem?.querySelector(".portfolio_editor .card .left")?.style.backgroundColor)
            : "#F2F2F2",
          sectionBody: currentElem?.querySelector(".section-body").style.backgroundColor
            ? RGBToHex(currentElem?.querySelector(".section-body").style.backgroundColor)
            : "#ffffff",
          sectionBorder: currentElem?.querySelector(".card").style.borderBottom
            ? RGBToHex(`rgb${currentElem?.querySelector(".card").style.borderBottom.split("rgb")[1]}`)
            : "#4472c4",
        }
      : metadata.activeWidgetType[0] === FRAME
      ? {
          shadow: currentElem.querySelector(" .dhp-widget-inner").style.filter,
          borderStyle: currentElem.dataset.borderStyle ? currentElem.dataset.borderStyle : "none",
          borderWidth: currentElem.dataset.borderWidth,
          borderRadius: 0,
          borderColor: currentElem.dataset.borderColor,
        }
      : metadata.activeWidgetType[0] === COUNTDOWN
      ? { shadow: currentElem.querySelector(" .dhp-widget-inner").style.filter }
      : currentElem.querySelector(" .dhp-widget-inner").style;
    let currentWidgetCssText = currentWidgetStyle.cssText;
    let multiColorDataClassSet = [];
    let multiColorSet = [];
    let multicolorClassSet = [];

    // create color array
    if (colorWidgetIncludedList.includes(currentElem.dataset.assetType)) {
      if (
        metadata.activeWidgetType[0] === ILLUSTRATION ||
        metadata.activeWidgetType[0] === STICKER ||
        metadata.activeWidgetType[0] === ICON ||
        (metadata.activeWidgetType[0] === TEXT_FRAME &&
          parseInt(document.getElementById(metadata.activeWidgetId[0]).getAttribute("data-version")) >= 3) ||
        (metadata.activeWidgetType[0] === UPLOAD && currentElem.dataset?.fileType === SVG)
      ) {
        currentElem.querySelectorAll(` svg *`).forEach(function (node) {
          let dataClassName = node.dataset.class;

          if (node.classList.value !== "") multicolorClassSet.push(node.classList.value);

          if (dataClassName) {
            let currentIconColor =
              window.getComputedStyle(node).fill === "rgba(0, 0, 0, 0)"
                ? "transparent"
                : RGBToHex(window.getComputedStyle(node).fill);

            if (!multiColorDataClassSet?.includes(dataClassName) && currentIconColor !== "") {
              multiColorDataClassSet.push(dataClassName);
              multiColorSet.push(hexToRGB(currentIconColor));
            }
          }
        });

        // //Manage Color for mono color Uploaded svg
        if (
          multiColorSet.length === 0 &&
          multicolorClassSet.length === 0 &&
          (metadata.activeWidgetType[0] === UPLOAD || metadata.activeWidgetType[0] === ICON)
        ) {
          let monoColor = currentElem.querySelector(` svg`)?.style?.fill;
          multiColorSet.push(monoColor);
        }
      }
      //Fetch color for Text widget
      else if (metadata.activeWidgetType[0] === TEXT) {
        multiColorSet.push(currentWidgetStyle.color);
      }
      //Fetch color for Text-Art widget
      else if (
        metadata.activeWidgetType[0] === TEXT_ART &&
        parseInt(
          document.querySelector(`#${metadata.activeWidgetId[0]} .text-content-editor`).getAttribute("data-color-count")
        ) === 1
      ) {
        multiColorSet.push(
          document.querySelector(`#${metadata.activeWidgetId[0]} .text-content-editor`).getAttribute("data-color-one")
        );
      }
      //Fetch color for QR Code
      else if (metadata.activeWidgetType[0] === QR_CODE) {
        currentElem.querySelectorAll(` svg *`).forEach(function (node) {
          if (node.nodeName !== "title") {
            let currentIconColor =
              window.getComputedStyle(node).fill === "rgba(0, 0, 0, 0)"
                ? "transparent"
                : RGBToHex(window.getComputedStyle(node).fill);

            multiColorSet.push(hexToRGB(currentIconColor));
          }
        });
      }
      //Fetch color for mono svg
      else if (metadata.activeWidgetType[0] !== UPLOAD) {
        multiColorSet.push(currentElem.querySelector(` svg`)?.style.fill);
      }
    }

    // fetch outline value
    let outline = false;
    if (outlineWidgetIncludeList.includes(currentElem.dataset.assetType)) {
      // fetch outline for text widget
      if (metadata.activeWidgetType[0] === TEXT) {
        let strokeValue = document.querySelector("#" + metadata.activeWidgetId[0] + " .dhp-widget-inner").style
          ?.webkitTextStroke;

        if (strokeValue) {
          let strokeArray = strokeValue.split(" ");
          let rgbValue =
            strokeArray[1] === "transparent"
              ? strokeArray[1]
              : RGBToHex(`${strokeArray[1]} ${strokeArray[2]} ${strokeArray[3]}`);
          outline = {
            enable: true,
            width: parseInt(strokeArray[0]),
            color: rgbValue,
          };
        } else {
          outline = {
            enable: false,
            width: "",
            color: "",
          };
        }
      }
      // fetch outline color text art widget
      else if (metadata.activeWidgetType[0] === TEXT_ART) {
        outline = {
          enable: document
            .querySelector("#" + metadata.activeWidgetId[0] + " .text-content-editor")
            .getAttribute("data-outline")
            ? true
            : false,
          width: document
            .querySelector("#" + metadata.activeWidgetId[0] + " .text-content-editor")
            .getAttribute("data-outline-width")
            ? parseInt(
                document
                  .querySelector("#" + metadata.activeWidgetId[0] + " .text-content-editor")
                  .getAttribute("data-outline-width")
              )
            : "",
          color:
            document
              .querySelector("#" + metadata.activeWidgetId[0] + " .text-content-editor")
              .getAttribute("data-outline-color") ?? "",
        };
      }
    }

    updateCopyStyle({
      ...copyStyle,
      enable: true,
      id: metadata.activeWidgetId[0],
      widgetType: metadata.activeWidgetType[0],
      style: currentWidgetStyle,
      cssText: currentWidgetCssText,
      opacity: currentElem.querySelector(" .dhp-widget-inner").style.opacity,
      dataset: {
        ...widgets[targetWidgetIndex].data,
        ...currentElem.querySelector(" .dhp-widget-inner").dataset,
        ...currentElem.querySelector(" .dhp-widget-inner").childNodes[0]?.dataset,
        ...currentElem.querySelector(" .media-parent")?.childNodes[0]?.dataset,
        ...currentElem.querySelector("svg image")?.dataset,
        ...currentElem.querySelector("svg video")?.dataset,
      },
      color: multiColorSet,
      outline: outline,
      config: metadata.activeWidgetType[0] === COUNTDOWN ? widgets[targetWidgetIndex]?.config : false,
    });
  };

  return (
    <li
      className={cx(style["toolset-group"], {
        [style["disabled"]]: isGroupWidget || widgets.length <= 1,
      })}>
      <div className={cx(style["toolset-item"], style["copy-style-wrap"])}>
        <span className={cx(style["toolset-action"], style["custom-tooltip"])} onClick={copyCurrentWidgetStyle}>
          <Icon icon="ui-copy-style" />
          {!props.more && <div className={cx(style["custom-tooltip-content"], style["top"])}>Copy Style</div>}
          {props.more && "Copy Style"}
        </span>
      </div>
    </li>
  );
};
CopyStyle.propTypes = {
  more: PropTypes.bool,
};

export default CopyStyle;
